export const version = "3.71";
export const domain = "https://nqapp.nurulquran.com"
